import { render, staticRenderFns } from "./BulmaRadioButton.vue?vue&type=template&id=4817fa9c"
import script from "./BulmaRadioButton.vue?vue&type=script&lang=js"
export * from "./BulmaRadioButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports